import { builderCompleteness, builderFromDoc } from './builder.ts';
import type { ProcessTreeDoc } from './schema.ts';

/** How much of a step of the tree is set: its details filled in, what is missing, and whether it is configured. */
export interface StepCompleteness {
  done: number;
  of: number;
  missing: string[];
  configured: boolean;
}

/**
 * How configured each step of a tree saved for projects is (Jason, 2026-10-07: "clearly highlight unconfigured steps in
 * any tree and always show its icon"), by the one rule the process tree page reads (core `builderCompleteness`): the
 * tree opened as that page opens it (`builderFromDoc`, lock-in's inverse), each step at the top of it read there. A
 * job's pages read it from the tree the job reads (the master as last saved, with the project's own settings over it),
 * so a step on a job whose master node is not configured is marked as the master marks it. By key, the steps at the
 * top of the tree alone (a task is in its step's list).
 */
export function lockedCompleteness(doc: ProcessTreeDoc): Map<string, StepCompleteness> {
  const t = builderFromDoc(doc);
  return new Map(t.nodes.filter((n) => n.parent === null).map((n) => [n.key, builderCompleteness(t, n)]));
}
